import { SubjectsBlockClientData } from '@yandex-int/k-common/typings/api/models/main-page';
import { ChevroneKit } from 'education-icons';
import { Button, H3, useAppContext } from 'platform-components';
import Carousel from 'platform-components/src/components/carousel/carousel';
import { UI_KIT_HEADER_TYPOGRAPHY } from 'platform-components/src/components/constants';
import React from 'react';
import ym from 'react-yandex-metrika';

import { ShowcaseMetrikaParams } from 'common.components/typings';

import { SubjectsWidgetItemView } from './__item/subjects__item';

import './subjects.scss';

interface Props {
    data: SubjectsBlockClientData;
    metrikaParams?: ShowcaseMetrikaParams;
}

export const SubjectsWidgetView = (props: Props) => {
    const { data, metrikaParams } = props;
    const { title, additional_info: additionalInfo } = data;
    const { subjects: items } = additionalInfo;

    const {
        uatraits: { isTouch },
    } = useAppContext();
    const shouldShowControls = !isTouch;

    const handleItemClick = (subjectSlug: string) => {
        ym('reachGoal', 'teacher_main_click_subject', { ...metrikaParams, subjectSlug });
    };

    return (
        <div className="subjects-widget">
            {title && (
                <H3 mix="subjects-widget__title" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMMedium}>
                    {title}
                </H3>
            )}
            <Carousel allowLinearScroll={true} mix="subjects-widget__carousel">
                {shouldShowControls && (
                    <Carousel.Controls>
                        <Carousel.Prev mix="subjects-widget__carousel-prev">
                            <Button icon={<ChevroneKit />} rounded={true} view={Button.VIEW.RAISED} />
                        </Carousel.Prev>
                        <Carousel.Next mix="subjects-widget__carousel-next">
                            <Button icon={<ChevroneKit />} rounded={true} view={Button.VIEW.RAISED} />
                        </Carousel.Next>
                    </Carousel.Controls>
                )}
                <Carousel.Content>
                    {items.map((item) => {
                        return (
                            <SubjectsWidgetItemView
                                item={item}
                                key={item.id}
                                onClick={() => handleItemClick(item.subject_slug)}
                            />
                        );
                    })}
                </Carousel.Content>
            </Carousel>
        </div>
    );
};
